// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3VFin","addWidgetButton":"Header_addWidgetButton__rQ8A1","dashboardTabs":"Header_dashboardTabs__36qzh","active":"Header_active__1Fjij"};